module.exports = __webpack_public_path__ + "static/assets/6e32ca556036c6f130a4dc8f2e28f726.svg";